// extracted by mini-css-extract-plugin
export default {"Customizado":"estilo_Customizado__FC+uZ","ContainerGrid2Colunas":"estilo_ContainerGrid2Colunas__gUZbc","Item_Pesquisa":"estilo_Item_Pesquisa__sCPRm"};